
export default {
  name: "blog",
  props: ["articles", "total", "totalPages"],
  head() {
    return {
      title: `295 blog`,
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Ανακάλύψε τον κόσμο της υγείας, ομορφιάς και ευεξίας στο 295 blog! Διαβάσε τα τελευταία νέα, τις τάσεις και  συμβουλές ειδικών στο νέο blog του pharmacy295.",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Ανακάλύψε τον κόσμο της υγείας, ομορφιάς και ευεξίας στο 295 blog! Διαβάσε τα τελευταία νέα, τις τάσεις και  συμβουλές ειδικών στο νέο blog του pharmacy295.",
        },
      ],
    };
  },
  data() {
    return {
      categories: [
        "Parenthood",
        "Beauty",
        "Health",
        "Fitness",
        "Nutrition",
        "Ευζήν",
      ],
      article: {},
      more: this.articles || [],
      top10: [],
      worth: [],
      header: [],
      featured: [],
      search: "",
      limit: 12,
      key: "q",
      email: "",
      page: 1,
      pages: this.totalPages,
      newsLetterAccept: false,
      elements:
        this.$store.getters.store.eshop.elements.filter(
          (e) =>
            e.page == "aux" &&
            e.position == "master" &&
            !this.$route.params.category &&
            !this.$route.query.q
        ) || [],
    };
  },
  async beforeCreate() {
    if (!this.$route.params.category && !this.$route.query.q) {
      [this.top10, this.worth, this.featured, this.header] = await Promise.all([
        this.$hyperBlog.getArticles("hidden_tags", "top10", 10),
        this.$hyperBlog.getArticles("hidden_tags", "worth", 3),
        this.$hyperBlog.getArticles("hidden_tags", "featured", 4),
        this.$hyperBlog.getArticles("hidden_tags", "header", 8),
      ]);
    }
  },
  methods: {
    async getMore() {
      this.page++;
      try {
        let m = await this.$hyperBlog.getArticles(this.key||'', this.$route.query.q||'', 12, this.page, true);
        this.more = this.more.concat(m.articles);
        this.pages = m.pages;
      } catch (error) {
        console.error(error);
      }
    },
    dirty() {
      if (!this.search) {
        return "";
      }
      return "dirty";
    },
    decode(text) {
      let entities = {
        amp: "&",
        apos: "'",
        "#x27": "'",
        "#x2F": "/",
        "#39": "'",
        "#47": "/",
        lt: "<",
        gt: ">",
        nbsp: " ",
        quot: '"',
      };
      return text.replace(/&([^;]+);/gm, function (match, entity) {
        return entities[entity] || match;
      });
    },
  },
};
